import { DELIVERY_CHALLAN_RETURN_REQUEST, CREATE_DELIVERY_CHALLAN_RETURN, GET_DELIVERY_CHALLAN_RETURNS, UPDATE_DELIVERY_CHALLAN_RETURN, DELETE_DELIVERY_CHALLAN_RETURN,
    DELIVERY_CHALLAN_RETURN_REQUEST_FAILURE, SET_CHALLAN_ORDERS, GET_DELIVERY_CHALLAN_RETURN_PAGE, DELIVERY_CHALLAN_RETURN_REQUEST_SUCCESS } from '../types';

const initialState = {
  deliveryChallanReturns: [],
  challanOrders: [],
  deliveryChallanReturnsPage: [],
  page: 1,
  pageSize: 10,
  search: '',
  where: {},
  total: 0,
  loading: false,
  error: null,
};

const deliveryChallanReturnReducer = (state = initialState, action) => {
  switch (action.type) {
    case DELIVERY_CHALLAN_RETURN_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case GET_DELIVERY_CHALLAN_RETURNS: {
      return {
        ...state,
        deliveryChallanReturns: [...action.payload],
        loading: false,
        error: null
      }
    }
    case CREATE_DELIVERY_CHALLAN_RETURN:
      return {
        ...state,
        deliveryChallanReturns: [action.payload, ...state.deliveryChallanReturns],
        loading: false,
        error: null
      };
    case UPDATE_DELIVERY_CHALLAN_RETURN:
      const deliveryChallanReturnsData = state.deliveryChallanReturns.slice(0);
      const uIndex = deliveryChallanReturnsData.findIndex((data) => data.id === action.payload.id);
      deliveryChallanReturnsData.splice(uIndex, 1, { ...action.payload.data });
      return {
        ...state,
        deliveryChallanReturns: [ ...deliveryChallanReturnsData ],
        loading: false,
        error: null
      };
    case DELIVERY_CHALLAN_RETURN_REQUEST_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null
      }
    }
    case GET_DELIVERY_CHALLAN_RETURN_PAGE: {
      const { data, total, page, pageSize, search, where } = action.payload || {};
      return {
        ...state,
        deliveryChallanReturnsPage: [...data],
        total,
        page,
        pageSize,
        search: search || '',
        where: where || {},
        loading: false,
        error: null
      }
    }
    case DELETE_DELIVERY_CHALLAN_RETURN:
      const deliveryChallanReturns = state.deliveryChallanReturns?.slice(0);
      const index = deliveryChallanReturns.findIndex((data) => data.id === action.id);
      if (index > -1) {
        deliveryChallanReturns.splice(index, 1);
      }
      return {
        ...state,
        deliveryChallanReturns: [...deliveryChallanReturns],
        loading: false,
        error: null
      }
    case DELIVERY_CHALLAN_RETURN_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    case SET_CHALLAN_ORDERS: {
        return {
          ...state,
          challanOrders: [...action.payload],
          loading: false,
          error: null
        }
      }
    default:
      return state;
  }
};

export default deliveryChallanReturnReducer;
